import { StartWithUnit } from '@core/state/operators/start-with-unit';
import { inject, Injectable } from '@angular/core';
import { ServiceForRoute } from '@api/models/MonitoringService/Contracts/service-for-route';
import { MonitoringService } from '@api/services/monitoring.service';
import { Observable } from 'rxjs';
import { CustomRxState } from '@core/state/rx.state';
import { ListSchemaServiceResponse } from '@api/models/MonitoringService/Contracts/New/list-schema-service-response';
import { GetSchemaServiceResponse } from '@api/models/MonitoringService/Contracts/New/get-schema-service-response';


interface IMonitoringSchemeState {
    loading: Record<StartWithUnit, boolean>;
    services: ListSchemaServiceResponse[];
}

@Injectable()
export class MonitoringSchemeState extends CustomRxState<IMonitoringSchemeState> {
    readonly #monitoringService: MonitoringService = inject(MonitoringService);

    public readonly services$: Observable<ListSchemaServiceResponse[]> = this.selectLazy('services', this.requestServices);

    constructor() {
        super();

        this.setDefaultState();
    }

    public getSchemaBySrvId(srvId: number): Observable<GetSchemaServiceResponse> {
        return this.#monitoringService.apiMonitoringGetSchemaServiceGet({ srvId });
    }

    public getSchemaByStationCode(stCode: string): Observable<GetSchemaServiceResponse> {
        return this.#monitoringService.apiMonitoringGetSchemaStationGet({ stCode });
    }

    private requestServices(): Observable<ServiceForRoute[]> {
        return this.#monitoringService.apiMonitoringListSchemaServiceGet();
    }

    private setDefaultState(): void {
        this.set({
            loading: null,
        });
    }

}
